import { Component, OnInit, ViewChild, ViewContainerRef, Input } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { DialogRef, DialogService, DialogCloseResult, DialogContentBase } from '@progress/kendo-angular-dialog';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { Enum } from 'src/app/models/enum.model';
import { Alert } from 'src/app/models/alert.model';

@Component({
  selector: 'app-alerts-form-component',
  templateUrl: './alerts-form.component.html'
})
export class AlertsFormComponent extends DialogContentBase implements OnInit {
  @ViewChild("container", { read: ViewContainerRef })
  public container: ViewContainerRef | undefined;
  public formGroup: FormGroup;
  public lEstadosAlerta: Enum[] = [];

  public formValue: Alert = {
    data: new Date(),
    tipoAlerta: 0,
    nomeTipoAlerta: '',
    estado: 0,
    nomeEstado: '',
    refUtilizador: 0,
    nomeUtilizador: '',
    idCartao: '',
    codigoFuncionario: '',
    refArmarioModuloCompartimento: 0,
    nomeCompartimento: '',
    nomeArmario: '',
    numeroDeSerieArmario: '',
    refMovimentoIV: 0,
    notas: '',
    dataAtualizacao: new Date(),
    id: 0,
  };

  public customMsgService: CustomMessagesService;

  constructor(
    private dialogService: DialogService,
    public msgService: MessageService,
    private notificationService: NotificationService,
    public override dialog: DialogRef,
    private api: ApiService,
    private formBuilder: FormBuilder,
  ) {
    super(dialog);
    this.customMsgService = this.msgService as CustomMessagesService;
    this.formGroup = this.formBuilder.group({
      notas: [''],
      estado: [null]
    });
  }

  ngOnInit(): void {
    this.api
      .getRequest<BaseHttpResponse<Enum[]>>("Alerta/GetEstadosAlerta")
      .then((data) => {
        this.lEstadosAlerta = data.value;
        this.setFormValues();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  public setFormValues() {
    this.formGroup.patchValue({
      notas: this.formValue.notas,
      estado: this.lEstadosAlerta.find(item => item.id === this.formValue.estado) || null
    });
  }

  public saveChanges(): void {
    this.formGroup.markAllAsTouched();
    const formValue = this.formGroup.value;
    this.formValue.estado = formValue.estado.id;
    this.formValue.notas = formValue.notas;

    this.api.save<BaseHttpResult>('Alerta/SaveAlerta', this.formValue).then(res => {
      if (res.ok) {
        this.formGroup.markAsPristine();
        this.dialog.close();
        this.notificationService.show({
          content: this.customMsgService.translate('registoGravadoComSucesso'),
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'bottom' },
          type: { style: 'success', icon: true },
          hideAfter: 2000
        });
      } else {
        this.notificationService.show({
          appendTo: this.container,
          content: res.message,
          animation: { type: 'slide', duration: 500 },
          position: { horizontal: 'center', vertical: 'top' },
          type: { style: 'error', icon: true },
          hideAfter: 4000
        });
      }
    }).catch(err => {
      console.error(err);
    });
  }

  public cancelChanges(): void {
    this.setFormValues();
  }

  public delete(e: any): void {
    var sim = this.customMsgService.translate('yes');
    var nao = this.customMsgService.translate('no');
    const dialog: DialogRef = this.dialogService.open({
      appendTo: this.container,
      title: this.customMsgService.translate('confirmacao'),
      content: this.customMsgService.translate('desejaRemover'),
      actions: [{ text: nao }, { text: sim, themeColor: "primary" }],
      width: 450,
      height: 200,
      minWidth: 250,
    });

    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
        // Do nothing
      } else if (result.text == sim) {
        this.api.cruddelete<BaseHttpResult>('Alerta', e.id)
          .then(res => {
            if (res.ok) {
              this.notificationService.show({
                appendTo: this.container,
                content: this.customMsgService.translate('registoApagadoComSucesso'),
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'top' },
                type: { style: 'success', icon: true },
                hideAfter: 2000
              });
            } else {
              this.notificationService.show({
                appendTo: this.container,
                content: res.message,
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'top' },
                type: { style: 'error', icon: true },
                hideAfter: 4000
              });
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    });
  }
}
